<script setup>
import { VueQueryDevtools } from '@tanstack/vue-query-devtools';
import dayjs from 'dayjs';
import { ElConfigProvider } from 'element-plus';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
import { RouterView } from 'vue-router';
import DevConfig from './components/DevConfig.vue';
import 'dayjs/locale/zh-cn';

// dayjs国际化
dayjs.locale('zh-cn');

const isDev = import.meta.env.DEV;
</script>

<template>
  <VueQueryDevtools button-position="bottom-left" />
  <ElConfigProvider :locale="zhCn" :message="{ max: 5, duration: 3000 }" namespace="tb">
    <RouterView />

    <!-- 系统配置 -->
    <DevConfig v-if="isDev" />
  </ElConfigProvider>
</template>
